/**
 * <ax-cross-select> — dropdown variante des cartes cross-sell (ax-product-card-cross).
 *
 * Le <details> natif gère l'ouverture/fermeture. Les options sont des radios
 * `name="id"` (value = variant id) : la variante cochée part directement dans le
 * FormData du product-form-component (ajout sans JS). Ce composant ne gère que le
 * visuel : mettre à jour le label du trigger + refermer le panneau à la sélection.
 */
class AxCrossSelect extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const label = this.querySelector('[data-cross-select-label]');
    if (label) label.textContent = input.dataset.label || input.value;

    // Reflète la sélection sur la ref variantId du form (lue par ProductFormComponent).
    const variantIdRef = this.closest('product-form-component')?.querySelector('[ref="variantId"]');
    if (variantIdRef instanceof HTMLInputElement) variantIdRef.value = input.value;

    const details = this.querySelector('details');
    if (details) details.open = false;
  };
}

if (!customElements.get('ax-cross-select')) {
  customElements.define('ax-cross-select', AxCrossSelect);
}
